module.exports = __webpack_public_path__ + "img/add-image.815028c7.png";